<script>
  import Modal from "./Modal.svelte";
  import Router from "svelte-spa-router";
  import { link, push } from "svelte-spa-router";
  import { slide, blur, fade, fly } from "svelte/transition";
  import Dashboard from "./Dashboard/Dashboard.svelte";
  import CreateProduct from "./Dashboard/CreateProduct.svelte";
  import CreateFactory from "./Dashboard/CreateFactory.svelte";
  import WageDistribution from "./Calculator/WageDistribution.svelte";
  import { setContext } from "svelte";
  import { loggedInUserStore } from "./store/loggedInUser.js";
  import { factoryStore } from "./store/factories.js";
  import { langTextStore } from "./store/langtexts.js";
  import CalculatorRoot from "./Calculator/CalculatorRoot.svelte";
  import ProductUpload from "./Dashboard/ProductUpload.svelte";
  //export let params
  let showInfoMessage = false;
  export let params = "";
  params = params;
  let msgIsSuccess = false;
  let infoMessage;
  $: loggedInEmail = $loggedInUserStore.email;
  factoryStore.getCurrencies();
  const snackbar = (type, message) => {
    infoMessage = message;
    if (type == "error") {
      msgIsSuccess = false;
    } else {
      msgIsSuccess = true;
    }
    showInfoMessage = true;
    window.setTimeout(() => {
      showInfoMessage = false;
    }, 2500);
  };

  setContext("app", { snackbar });

  $: redirectToStartPageIfNeeded($loggedInUserStore);

  async function redirectToStartPageIfNeeded(theuser) {
    if (theuser && theuser.uuid && theuser.uuid.length > 0) {
      if (!theuser.seenTour) {
        if (window.location.href.includes("settings")) {
          window.setTimeout(() => {
            window.open("/fullscreen/tour", "_self");
          }, 50);
        } else {
          push("/fullscreen/tour");
        }
        return;
      }
      //  var hasFactories = await factoryStore.hasFactories();

      // if (!hasFactories) {
      //   push("/createfactory");
      //   return;
      // }
    }
  }

  function logout() {
    if (showInfoMessage) {
      window.setTimeout(() => {
        loggedInUserStore.logout();
        window.setTimeout(() => {
          window.open("/", "_self");
        }, 500);
      }, 500);
    } else {
      loggedInUserStore.logout();
      window.setTimeout(() => {
        window.open("/", "_self");
      }, 500);
    }
  }

  const routes = {
    "/": Dashboard,
    "/Dashboard": Dashboard,
    "/Dashboard/:sectionName": Dashboard,
    "/wagedistribution/:factorySettingsId": WageDistribution,
    "/CreateFactory": CreateFactory,
    "/createproduct/": CreateProduct,
    "/createproduct/:factorySettingsId": CreateProduct,
    "/Calculator/*": CalculatorRoot,
    "/ProductUpload/": ProductUpload,
  };
</script>

<Modal closeOnOuterClick={false}>
  {#if showInfoMessage}
    {#if msgIsSuccess}
      <div
        class="snackbar snackbar-success"
        role="alert"
        transition:fly|local={{ y: 200, duration: 600 }}
      >
        <!-- <button aria-label="" class="close" data-dismiss="alert" /> -->
        <!-- <strong>{$langTextStore.getText("general-labels-information")}:</strong> -->
        {@html infoMessage}
      </div>
    {:else}
      <div
        class="snackbar snackbar-danger"
        role="alert"
        transition:fly|local={{ y: 200, duration: 100 }}
      >
        <!-- <button aria-label="" class="close" data-dismiss="alert" />
        <strong>{$langTextStore.getText("general-labels-error")}:</strong> -->
        {@html infoMessage}
      </div>
    {/if}
  {/if}

  <div
    class:hidden={!$factoryStore.isBusySync}
    class:flexcenter={$factoryStore.isBusySync}
  >
    Please wait while we sync your data from the server...
  </div>

  <div class:hidden={$factoryStore.isBusySync}>
    <Router {routes} />
  </div>
</Modal>

<style>
  :global(.fakelink) {
    cursor: pointer;
    display: block;
    pointer-events: fill;
  }
  .hidden {
    display: none;
  }
  .flexcenter {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
</style>
